module.exports = __webpack_public_path__ + "img/new-afpi.ba976df3.png";